// generated from 1_084 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const deviceOsFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("device_os_filter"),
  comparison_key: z.enum([
    "1", // 451 (41.61%)
    "25", // 257 (23.71%)
    "26", // 162 (14.94%)
    "27", // 100 (9.23%)
    "28", // 56 (5.17%)
    "2", // 48 (4.43%)
    "11", // 10 (0.92%)
  ]),
  display_name: z.string(),
  // undefined: 443 (40.87%), defined 641 (59.13%)
  raw_value: z
    .union([
      // string samples: 208 (32.45%)
      z.string(),
      // array samples: 433 (67.55%)
      z.array(z.string()),
    ])
    .optional(),
  value: z.union([
    // string samples: 509 (46.96%)
    z.string(),
    // array samples: 575 (53.04%)
    z.array(z.string()),
  ]),
  varies_by_app_group: z.literal(true),
});
